// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record } from "immutable"

import isUndefined from "../../utils/isUndefined"

export type InfantsInputConditions = {
  trolley?: boolean
  stroller?: boolean
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  hand_weight?: number
}

export const InfantsConditions = Record({
  trolley: undefined,
  differentHandWeight: false,
  handWeight: undefined,
})

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
const mapperInfantsConditions = (conditions?: InfantsInputConditions | null): InfantsConditions => {
  let infantsConditions = new InfantsConditions()

  if (!conditions) return infantsConditions

  // Trolley
  if (!isUndefined(conditions.trolley)) {
    infantsConditions = infantsConditions.set("trolley", conditions.trolley)
  }

  // Stroller - BookingApi now incorrectly returns "stroller" instead of "trolley", TODO: remove after api fix
  if (!isUndefined(conditions.stroller)) {
    infantsConditions = infantsConditions.set("trolley", conditions.stroller)
  }

  // Custom hand weight
  if (!isUndefined(conditions.hand_weight)) {
    infantsConditions = infantsConditions.set("handWeight", conditions.hand_weight)
    infantsConditions = infantsConditions.set("differentHandWeight", true) // use custom hand weight for infants
  }

  return infantsConditions
}

export default mapperInfantsConditions
